import React from 'react';
import SVGLoader from './SVGLoader';

const LatLongIcon = props => {
  return (
    <SVGLoader
      {...props}
      width={13}
      height={25}
      viewboxHeight={11}
      viewboxWidth={10}
    >
      <path
        d="M5,0a.372.372,0,0,0-.326.193A10.756,10.756,0,0,0,3.356,4.225a.251.251,0,0,0,.249.275H6.4a.251.251,0,0,0,.249-.275A10.711,10.711,0,0,0,5.329.2.376.376,0,0,0,5,0Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M3.605,5.5a.251.251,0,0,0-.249.275,10.693,10.693,0,0,0,1.315,4.03.373.373,0,0,0,.655,0A10.744,10.744,0,0,0,6.644,5.775.251.251,0,0,0,6.4,5.5Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M7.653,4.27A.249.249,0,0,0,7.9,4.5H9.691a.251.251,0,0,0,.247-.29A5.019,5.019,0,0,0,7.068.448a.25.25,0,0,0-.332.328A10.98,10.98,0,0,1,7.653,4.27Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M2.1,4.5a.249.249,0,0,0,.249-.23A10.98,10.98,0,0,1,3.264.776.25.25,0,0,0,2.932.448,5.019,5.019,0,0,0,.062,4.21a.254.254,0,0,0,.057.2.25.25,0,0,0,.19.088Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M7.9,5.5a.249.249,0,0,0-.249.23,10.98,10.98,0,0,1-.917,3.494.25.25,0,0,0,.332.328A5.021,5.021,0,0,0,9.938,5.79a.254.254,0,0,0-.057-.2.25.25,0,0,0-.19-.088Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M2.347,5.73A.249.249,0,0,0,2.1,5.5H.309a.251.251,0,0,0-.247.29,5.021,5.021,0,0,0,2.87,3.762.25.25,0,0,0,.332-.328A10.98,10.98,0,0,1,2.347,5.73Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
    </SVGLoader>
  );
};

export default LatLongIcon;
